import { isPromise } from 'bold-ui'
import { handleError } from 'components/error'
import { ErrorObject } from 'util/validation'

import { ResultType } from './Form'

export async function defaultTransformResult<T = any>(
  result: ResultType,
  suppressNotificationError: boolean,
  suppressValidationError: boolean,
  supressFieldValidationNotificationError: boolean
): Promise<void | ErrorObject<T>> {
  if (!result || !isPromise(result)) {
    return result
  }

  try {
    await result
  } catch (error) {
    return handleError({
      error,
      suppressNotificationError,
      suppressValidationError,
      supressFieldValidationNotificationError,
    })
  }
}
